import get from "lodash/get";
import {
    cancelInvoiceClientLoading,
    cancelInvoiceClientReject,
    cancelInvoiceClientRequest,
    cancelInvoiceClientSuccess,
    cancelInvoiceClientReset,
} from "../../actions/invoiceClient/cancel";

export const cancelInvoiceClient = (body) => async (dispatch, getState) => {
    dispatch(cancelInvoiceClientLoading());
    try {
        const { data } = await cancelInvoiceClientRequest(body, getState);
        dispatch(cancelInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(cancelInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(cancelInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
